/* eslint-disable react/jsx-wrap-multilines */
import * as React from 'react';
import { useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { CmdTooltip } from '@commander-services/gui-components';
import { IRide } from '../types';
import {
  activeRideIndexAtom,
  actualPlayPositionAtom,
  selectedRidesAtom,
  showDataLayerAtom,
} from '../RidePlayerState';

interface IDatePlaceWidgetProps {
  size?: number;
  rides: IRide[];
}

export default function DatePlaceWidget(props: IDatePlaceWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const actualPosition = useRecoilValue<number>(actualPlayPositionAtom);
  const showContent = useRecoilValue<boolean>(showDataLayerAtom);
  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];
  const rideIndex = activeRideNumber - 1;

  return (
    <div className="item">
      <div
        className={`b-widget b-widget--1x${props.size || 3} b-widget--alignLeft`}
        style={{ position: 'initial' }}
      >
        <div className="row no-gutters my-1">
          <div className="col-auto">
            <i className="e-widget-icon cmd-icon cmd-icon-arrival-time-2" />
          </div>
          <div className="col">
            <div className="e-widget-title fs-2">
              {' '}
              {showContent &&
              props.rides[rideIndex] &&
              props.rides[rideIndex].positions &&
              props.rides[rideIndex].positions[actualPosition] &&
              props.rides[rideIndex].positions[actualPosition].timestamp ? (
                <CmdTooltip
                  width={200}
                  content={<>{f({ id: 'ridePlayer.widget.datePlace.date.toolitp' })}</>}
                >
                  <span className="fs-4">
                    <strong>
                      {dayjs(props.rides[rideIndex].positions[actualPosition].timestamp).format(
                        'DD.MM.YYYY'
                      )}
                    </strong>
                    ,{' '}
                    {dayjs(props.rides[rideIndex].positions[actualPosition].timestamp).format(
                      'HH:mm:ss'
                    )}
                  </span>
                </CmdTooltip>
              ) : (
                '-'
              )}
            </div>
          </div>
        </div>
        <div className="row no-gutters my-1">
          <div className="col-auto">
            <i className="e-widget-icon cmd-icon cmd-icon-city" />
          </div>
          <div className="col">
            <div className="e-widget-title fs-2">
              {showContent &&
              props.rides[rideIndex] &&
              props.rides[rideIndex].positions &&
              props.rides[rideIndex].positions[actualPosition] &&
              props.rides[rideIndex].positions[actualPosition].gpsLat &&
              props.rides[rideIndex].positions[actualPosition].gpsLon ? (
                <CmdTooltip
                  content={
                    <div style={{ width: '150px' }}>
                      {props.rides[rideIndex].positions[actualPosition].address ||
                        `${props.rides[rideIndex].positions[actualPosition].gpsLat}, ${props.rides[rideIndex].positions[actualPosition].gpsLon}`}
                    </div>
                  }
                  width={200}
                  style={{ display: 'block' }}
                >
                  <div className="text-truncate">
                    <strong className="fs-3">
                      {props.rides[rideIndex].positions[actualPosition].address ||
                        `${props.rides[rideIndex].positions[actualPosition].gpsLat}, ${props.rides[rideIndex].positions[actualPosition].gpsLon}`}
                    </strong>
                  </div>
                </CmdTooltip>
              ) : (
                '-'
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
